import { render } from "./list-assessors.vue?vue&type=template&id=76483873"
import script from "./list-assessors.vue?vue&type=script&lang=js"
export * from "./list-assessors.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__